module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-21.22ca91ed.png";